/* 07 お届けのこと（2026-10-02）：送り状。お届け先と食数を選ぶと、送料ページの早見表と同じ金額を出す。
   ・何も選んでいないときは本番の文言（1,300円〜／冷凍料金込み。地域とそばの食数で決まります。）
   ・沖縄・離島、21食以上は、送料ページと同じ「ご注文前にお問い合わせください」の案内（同梱の「送料はそのまま」は薄くし、印は外す）
   ・画面に入ったら、枠が右下にずれて、最後に朱の「和」を押す（動きを減らす設定では最初から押してある） */
(() => {
  const yen = (s) => parseInt(String(s).replace(/[^\d]/g, ''), 10) || 0;
  const init = (sec) => {
    if (sec.dataset.kg7) return;
    sec.dataset.kg7 = '1';
    sec.classList.add('kg7--armed');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) sec.classList.add('is-in', 'kg7--stamped');
    else {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        sec.classList.add('is-in');
        setTimeout(() => sec.classList.add('kg7--stamped'), 1800);
      }), { threshold: .35, rootMargin: '0px 0px -8% 0px' });
      io.observe(sec.querySelector('.kg7__slip') || sec);
    }

    const json = sec.querySelector('[data-kg7-rates]');
    const sel = sec.querySelector('[data-kg7-pref]');
    const fee = sec.querySelector('[data-kg7-fee]');
    const note = sec.querySelector('[data-kg7-note]');
    const slip = sec.querySelector('[data-kg7-slip]');
    if (!json || !sel || !fee || !note) return;
    let data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    const radios = [...sec.querySelectorAll('.kg7__counts input')];
    const fee0 = fee.innerHTML;
    const note0 = note.innerHTML;
    const unit = (size) => (data.unit || '').replace('{size}', size);

    const show = (big, small, opts = {}) => {
      if (big == null) fee.innerHTML = fee0;
      else if (fee.textContent !== big) {
        fee.textContent = '';
        /* 案内文は文ごとに行を分ける（スマホで「ご／注文前に」と切れないように） */
        (opts.text ? big.replace(/。/g, '。\n').split('\n').filter(Boolean) : [big]).forEach((s) => { fee.appendChild(document.createElement('span')).textContent = s; });
      }
      if (fee.textContent !== show.last) {
        show.last = fee.textContent;
        fee.classList.remove('is-flip');
        void fee.offsetWidth;
        fee.classList.add('is-flip');
      }
      fee.classList.toggle('is-text', !!opts.text);
      if (small == null) note.innerHTML = note0; else note.textContent = small;
      if (slip) slip.classList.toggle('is-ask', !!opts.ask);
    };
    show.last = fee.textContent;

    const update = () => {
      const o = sel.options[sel.selectedIndex];
      const p = sel.value && o ? (o.dataset.r || '') : '';
      const pref = p ? o.text : '';
      const n = radios.find((r) => r.checked);
      if (p === 'remote') return show(data.remote, '', { text: true, ask: true });
      if (n && n.value === 'over') return show(data.over, '', { text: true, ask: true });
      const col = n ? parseInt(n.value, 10) : -1;
      const size = n ? n.dataset.size : '';
      if (p !== '') {
        const r = data.rates[parseInt(p, 10)];
        if (!r) return show(null, null);
        if (col < 0) return show(`${r.fees[0]}〜`, `${pref}（${r.region}）・そばの食数で決まります。`);
        return show(r.fees[col], `${unit(size)}（${pref}）`);
      }
      if (col >= 0) {
        const min = data.rates.reduce((a, r) => (yen(r.fees[col]) && (!a || yen(r.fees[col]) < yen(a)) ? r.fees[col] : a), '');
        return show(`${min}〜`, `${unit(size)}・お届け先で決まります。`);
      }
      return show(null, null);
    };
    sel.addEventListener('change', update);
    radios.forEach((r) => r.addEventListener('change', update));
    if (sel.value || radios.some((r) => r.checked)) update();
  };
  const run = () => document.querySelectorAll('.kg7--slip').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
